import { match } from 'ts-pattern'

import {
  NATIVE_TITLE_SIZE,
  v2InfoModal,
  v2InfoNoteText,
  v2Text,
} from '@flows/configs/petHealthV2/steps/elements/shared'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { ElementFragment } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import { BaseSchema_PetHealthV2GetsafeDe } from '@flows/insurance/schemas'

const postalCodeInfo = (placement: 'inline' | 'modal') =>
  match(placement)
    .with(
      'modal',
      () =>
        ({
          title: {
            type: 'title',
            text: v2Text('steps.postal_code.title'),
            infoButton: v2InfoModal('steps.postal_code'),
          },
          infoBoxes: [],
        }) as const
    )
    .with(
      'inline',
      () =>
        ({
          title: {
            type: 'title',
            text: v2Text('steps.postal_code.title'),
            size: NATIVE_TITLE_SIZE,
          },
          infoBoxes: [
            {
              type: 'infoBox',
              showInfoIcon: true,
              noPadding: true,
              contentConfiguration: [v2InfoNoteText('steps.postal_code.info')],
            },
          ],
        }) as const
    )
    .exhaustive()

export const postalCodeElements = (
  params: StepConfigParams,
  infoPlacement: 'inline' | 'modal' = 'inline'
) => {
  const { title, infoBoxes } = postalCodeInfo(infoPlacement)
  return {
    elements: [
      title,
      {
        type: 'codeInput',
        numberOfDigits: 5,
        autoCompleteType: 'postalCode',
        name: params.helperFunctions.getParamPath('zip_code'),
      },
      ...infoBoxes,
    ],
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('zip_code')]:
        BaseSchema_PetHealthV2GetsafeDe.shape.zip_code,
    }),
  } as const satisfies ElementFragment
}
